/*
  Print Shop filtering and sorting.

  Operates on the server-rendered grid: no fetching, no re-templating. Cards carry their
  own facet values on data- attributes (see snippets/print-shop.liquid), so filtering is a
  single pass over a static NodeList and sorting reorders the same nodes.

  Without JavaScript the full grid still renders and every card is reachable, which keeps
  the page usable and crawlable.
*/
(function () {
  var root = document.querySelector('[data-print-filter]');
  var grid = document.querySelector('[data-print-grid]');
  if (!root || !grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-print-item]'));
  var countEl = root.querySelector('[data-print-count]');
  var sortEl = root.querySelector('[data-print-sort]');
  var searchEl = root.querySelector('[data-print-search]');
  var emptyEl = document.querySelector('[data-print-empty]');
  var resetButtons = Array.prototype.slice.call(document.querySelectorAll('[data-print-reset]'));
  var total = items.length;

  // Preserve the server-rendered order so "Featured" can always be restored.
  items.forEach(function (item, index) {
    item.dataset.printOrder = String(index);
  });

  var state = { collection: 'all', format: 'all', price: 'all', search: '', sort: 'featured' };

  function matchesPrice(value, band) {
    if (band === 'all') return true;
    var bounds = band.split('-');
    var price = parseFloat(value);
    return price >= parseFloat(bounds[0]) && price <= parseFloat(bounds[1]);
  }

  function apply() {
    var visible = 0;

    items.forEach(function (item) {
      var okCollection =
        state.collection === 'all' ||
        (' ' + item.dataset.collection + ' ').indexOf(' ' + state.collection + ' ') !== -1;
      var okFormat = state.format === 'all' || item.dataset.format === state.format;
      var okPrice = matchesPrice(item.dataset.price, state.price);
      var okSearch = state.search === '' || item.dataset.title.indexOf(state.search) !== -1;
      var show = okCollection && okFormat && okPrice && okSearch;

      // Toggle a class rather than inline display so the CSS reveal transition can run.
      item.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });

    var sorted = items.slice().sort(function (a, b) {
      switch (state.sort) {
        case 'price-asc':
          return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        case 'price-desc':
          return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        case 'title-asc':
          return a.dataset.title.localeCompare(b.dataset.title);
        case 'title-desc':
          return b.dataset.title.localeCompare(a.dataset.title);
        default:
          return Number(a.dataset.printOrder) - Number(b.dataset.printOrder);
      }
    });

    // Re-append in sorted order. appendChild moves existing nodes, so this costs one
    // reflow and never destroys the already-loaded cover images.
    sorted.forEach(function (item) {
      grid.appendChild(item);
    });

    if (countEl) {
      if (visible === total) {
        countEl.textContent = 'Showing all ' + total + ' editions';
      } else if (visible === 1) {
        countEl.textContent = 'Showing 1 of ' + total + ' editions';
      } else {
        countEl.textContent = 'Showing ' + visible + ' of ' + total + ' editions';
      }
    }

    if (emptyEl) emptyEl.hidden = visible !== 0;

    var filtered =
      state.collection !== 'all' || state.format !== 'all' || state.price !== 'all' || state.search !== '';
    resetButtons.forEach(function (button) {
      if (button.closest('[data-print-empty]')) return;
      button.hidden = !filtered;
    });
  }

  root.querySelectorAll('[data-print-facet]').forEach(function (group) {
    var key = group.dataset.printFacet;
    group.addEventListener('click', function (event) {
      var button = event.target.closest('.print-pill');
      if (!button) return;
      group.querySelectorAll('.print-pill').forEach(function (pill) {
        pill.classList.toggle('is-active', pill === button);
      });
      state[key] = button.dataset.value;
      apply();
    });
  });

  if (sortEl) {
    sortEl.addEventListener('change', function () {
      state.sort = sortEl.value;
      apply();
    });
  }

  if (searchEl) {
    var debounce;
    searchEl.addEventListener('input', function () {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(function () {
        state.search = searchEl.value.trim().toLowerCase();
        apply();
      }, 140);
    });
  }

  resetButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state = { collection: 'all', format: 'all', price: 'all', search: '', sort: state.sort };
      if (searchEl) searchEl.value = '';
      root.querySelectorAll('[data-print-facet]').forEach(function (group) {
        group.querySelectorAll('.print-pill').forEach(function (pill) {
          pill.classList.toggle('is-active', pill.dataset.value === 'all');
        });
      });
      apply();
    });
  });

  apply();
})();
